import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const fetchSetting = createAction(ACTION.FETCH_SETTING.REQUEST);
export const fetchDetailSetting = createAction(ACTION.FETCH_DETAIL_SETTING.REQUEST);
export const updateSetting = createAction(ACTION.UPDATE_SETTING.REQUEST, (params) => ({...params}));
export const setDetail = createAction(ACTION.SET_DETAIL);
